import React, {
    useEffect,
    useRef,
    useState
}
from "react";

import {
    useHistory,
    useParams
}
from "react-router-dom";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InsightsDrawer
from "./components/InsightsDrawer";

import {
    faArrowLeft,
    faLayerGroup
}
from "@fortawesome/free-solid-svg-icons";

import useInsights from "./hooks/useInsights";


import InsightDetail
from "./components/InsightDetail";

import ObservationDetail
from "./components/ObservationDetail";

import PotentialAssetDetail
from "./components/PotentialAssetDetail";


export default function Insight()
{

	const initialPanoramaRef =
	    useRef(null);
	const viewerRef =
	    useRef(null);

	const history =
	    useHistory();

	const { id } =
	    useParams();

		const {
		    insight,
		    insightLoading,

		    panoramaInsightList,
		    panoramaObservationList,
		    panoramaPotentialAssetList,

		    panoramaInsightListLoading,
		    panoramaObservationListLoading,
		    panoramaPotentialAssetListLoading,

		    loadInsight,

		    loadInsightListForPanorama,
		    loadObservationListForPanorama,
		    loadPotentialAssetListForPanorama,

		    clearInsight,

		    clearPanoramaInsightList,
		    clearPanoramaObservationList,
		    clearPanoramaPotentialAssetList

		} = useInsights();

	const [showInsightDrawer, setShowInsightDrawer] =
	    useState(false);
		
	const [selectedItemType, setSelectedItemType] =
	    useState("INSIGHT");

	const [selectedItem, setSelectedItem] =
	    useState(null);
	
	
	const [
	    selectedPanoramaId,
	    setSelectedPanoramaId
	] =
	    useState(null);
		
		
	const otherInsights =
	    panoramaInsightList.filter(
	        (panoramaInsight) =>
	        {
	            return (
	                String(panoramaInsight.id)
	                !==
	                String(insight?.id)
	            );
	        }
	    );
		
		
		const panoramaDataLoading =
		    panoramaInsightListLoading
		    ||
		    panoramaObservationListLoading
		    ||
		    panoramaPotentialAssetListLoading;


			//--------------------------------------------------------
			// Set selected item from loaded insight
			//--------------------------------------------------------

			useEffect(
			    () =>
			    {
			        if(!insight)
			        {
			            return;
			        }

			        setSelectedItemType("INSIGHT");
			        setSelectedItem(insight);
			    },
			    [insight]
			);		

    //--------------------------------------------------------
    // Load insight
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(id)
            {
                loadInsight(id);
            }

            return () =>
            {
                clearInsight();
            };
        },
        [id]
    );
	
	
	//--------------------------------------------------------
	// Set initial panorama from insight
	//--------------------------------------------------------

	useEffect(
	    () =>
	    {
	        const panoramaId =
	            insight?.giraffePanoramaId;

	        if(!panoramaId)
	        {
	            initialPanoramaRef.current = null;
	            setSelectedPanoramaId(null);
	            return;
	        }

	        initialPanoramaRef.current =
	            panoramaId;

	        setSelectedPanoramaId(
	            panoramaId
	        );
	    },
	    [
	        insight?.id,
	        insight?.giraffePanoramaId
	    ]
	);


	//--------------------------------------------------------
	// Refresh insights for selected panorama
	//--------------------------------------------------------

	//--------------------------------------------------------
	// Refresh location intelligence for selected panorama
	//--------------------------------------------------------

	useEffect(
	    () =>
	    {
	        if(!selectedPanoramaId)
	        {
	            clearPanoramaInsightList();
	            clearPanoramaObservationList();
	            clearPanoramaPotentialAssetList();

	            return;
	        }

	        console.log(
	            "LOADING LOCATION INTELLIGENCE FOR PANORAMA:",
	            selectedPanoramaId
	        );

	        loadInsightListForPanorama(
	            selectedPanoramaId
	        );

	        loadObservationListForPanorama(
	            selectedPanoramaId
	        );

	        loadPotentialAssetListForPanorama(
	            selectedPanoramaId
	        );
	    },
	    [selectedPanoramaId]
	);

	//--------------------------------------------------------
	// Listen for Giraffe panorama changes
	//--------------------------------------------------------

	useEffect(
	    () =>
	    {
	        function handleGiraffeMessage(event)
	        {
	            if(
	                event.origin
	                !==
	                "https://tour.giraffe360.com"
	            )
	            {
	                return;
	            }

	            if(
	                event.source
	                !==
	                viewerRef.current?.contentWindow
	            )
	            {
	                return;
	            }

	            const sceneKey =
	                event.data?.sceneKey
	                ||
	                event.data?.scene_key
	                ||
	                event.data?.sceneId
	                ||
	                event.data?.scene_id
	                ||
	                event.data?.panoKey
	                ||
	                event.data?.panoramaId;

	            if(!sceneKey)
	            {
	                return;
	            }

	            /*
	             * The iframe emits its default/current panorama
	             * during startup. Keep the insight panorama as
	             * the initial selection.
	             */

	            if(initialPanoramaRef.current)
	            {
	                console.log(
	                    "IGNORING INITIAL GIRAFFE PANORAMA:",
	                    sceneKey
	                );

	                initialPanoramaRef.current =
	                    null;

	                return;
	            }

	            setSelectedPanoramaId(
	                (currentPanoramaId) =>
	                {
	                    if(currentPanoramaId === sceneKey)
	                    {
	                        return currentPanoramaId;
	                    }

	                    console.log(
	                        "GIRAFFE PANORAMA CHANGED:",
	                        currentPanoramaId,
	                        "→",
	                        sceneKey
	                    );
						
	                    return sceneKey;
	                }
	            );
	        }

	        window.addEventListener(
	            "message",
	            handleGiraffeMessage
	        );

	        return () =>
	        {
	            window.removeEventListener(
	                "message",
	                handleGiraffeMessage
	            );
	        };
	    },
	    []
	);


    //--------------------------------------------------------
    // Formatting
    //--------------------------------------------------------

    function displayValue(value)
    {
        if(
            value === null
            ||
            value === undefined
            ||
            value === ""
        )
        {
            return "—";
        }

        return value;
    }


    function formatMoney(value)
    {
        if(value === null || value === undefined)
        {
            return "—";
        }

        return new Intl.NumberFormat(
            "en-GB",
            {
                style: "currency",
                currency: "GBP",
                maximumFractionDigits: 0
            }
        ).format(value);
    }


    function severityColour(severity)
    {
        switch((severity || "").toUpperCase())
        {
            case "CRITICAL":
                return "#ef3f45";

            case "HIGH":
                return "#ff6b13";

            case "MEDIUM":
                return "#f2b321";

            case "LOW":
                return "#20a15a";

            default:
                return "#7d8796";
        }
    }


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (
        <div style={pageStyle}>

            <Header
                showSurveySelector={false}
                transitionHide={true}
            />

            <LeftMenu />

            <main style={contentStyle}>

                <div style={detailPanelStyle}>
				{
				    insightLoading
				    ?
				        <div style={messageStyle}>

				            <div style={spinnerStyle} />

				            <div style={messageTitleStyle}>
				                Loading insight
				            </div>

				            <div style={messageTextStyle}>
				                Retrieving insight details...
				            </div>

				        </div>
				    :
				    selectedItem
				    ?
				        <>
				            <div style={detailNavigationStyle}>

				                <button
				                    type="button"
				                    style={backButtonStyle}
				                    onClick={() =>
				                       history.goBack()
				                    }
				                >
				                    <FontAwesomeIcon
				                        icon={faArrowLeft}
				                    />

				                    Back to insights
				                </button>

				            </div>


				            {
				                selectedItemType === "INSIGHT"
				                &&
				                <InsightDetail
				                    insight={selectedItem}
				                />
				            }


				            {
				                selectedItemType === "OBSERVATION"
				                &&
				                <ObservationDetail
				                    observation={selectedItem}
				                />
				            }


				            {
				                selectedItemType === "ASSET"
				                &&
				                <PotentialAssetDetail
				                    potentialAsset={selectedItem}
				                />
				            }

				        </>
				    :
				        <div style={messageStyle}>

				            <div style={messageTitleStyle}>
				                Item unavailable
				            </div>

				            <div style={messageTextStyle}>
				                The requested item could not be loaded.
				            </div>

				        </div>
				}
                    
					<div style={actionBarStyle}>

					    <button
					        type="button"
					        style={primaryActionStyle}
					        onClick={() =>
					        {
					            console.log("Create work order", insight.id);
					        }}
					    >
					        Create Work Order
					    </button>

					    <button
					        type="button"
					        style={secondaryActionStyle}
					        onClick={() =>
					        {
					            console.log("Assign to project", insight.id);
					        }}
					    >
					        Assign To Project
					    </button>

					    <button
					        type="button"
					        style={mergeActionStyle}
					        onClick={() =>
					        {
					            console.log("Merge insight", insight.id);
					        }}
					    >
					        Merge
					    </button>

					</div>
                </div>
				

                <div style={viewerFrameStyle}>

                    <iframe
                        ref={viewerRef}
                        style={frameStyle}
                        src={
                            "https://tour.giraffe360.com/"
                            +
                            "49c74ed43a75417c96cf6a2684fac357" + 
							"/?scene=CAM03182G0-PR0015-PAN010"
                        }
                        title="Panorama scan"
                        allowFullScreen
                    />
					{
					       insight?.giraffePanoramaId
					       &&
					       <button
					           type="button"
					           style={otherInsightsButtonStyle}
					           disabled={panoramaInsightListLoading}
					           onClick={() =>
					           {
					               setShowInsightDrawer(true);
					           }}
					       >

					           <span style={otherInsightsIconStyle}>

					               <FontAwesomeIcon
					                   icon={faLayerGroup}
					               />

					           </span>

					           <span style={otherInsightsTextStyle}>

					               <span style={otherInsightsLabelStyle}>
					                   {
					                       panoramaDataLoading
					                       ?
					                           "Loading Intelligence..."
					                       :
					                           "Location Intelligence"
					                   }
					               </span>

					               {
					                   !panoramaDataLoading
					                   &&
					                   <span style={otherInsightsCountTextStyle}>
					                       {selectedPanoramaId}
					                   </span>
					               }

					           </span>

					           {
					               !panoramaDataLoading
					               &&
					               <span style={otherInsightsCountStyle}>
					                   {otherInsights.length}
					               </span>
					           }

					       </button>
					   }
                </div>

            </main>
			<InsightsDrawer
			    display={showInsightDrawer}

			    title="Location Intelligence"

			    insights={otherInsights}
			    observations={panoramaObservationList}
			    potentialAssets={panoramaPotentialAssetList}

			    loading={panoramaInsightListLoading}
			    observationsLoading={panoramaObservationListLoading}
			    potentialAssetsLoading={
			        panoramaPotentialAssetListLoading
			    }

			    closeFunction={() =>
			    {
			        setShowInsightDrawer(false);
			    }}

				clickFunction={(selectedInsight) =>
				{
				    setSelectedItemType("INSIGHT");
				    setSelectedItem(selectedInsight);

				    setShowInsightDrawer(false);
				}}

				observationClickFunction={(selectedObservation) =>
				{
				    setSelectedItemType("OBSERVATION");
				    setSelectedItem(selectedObservation);

				    setShowInsightDrawer(false);
				}}

				potentialAssetClickFunction={(selectedAsset) =>
				{
				    setSelectedItemType("ASSET");
				    setSelectedItem(selectedAsset);

				    setShowInsightDrawer(false);
				}}
			/>
        </div>
    );
}


//--------------------------------------------------------
// Detail block
//--------------------------------------------------------

function DetailBlock({
    icon,
    title,
    children
})
{
    return (
        <div style={detailBlockStyle}>

            <div style={blockHeadingStyle}>

                {
                    icon
                    &&
                    <FontAwesomeIcon
                        icon={icon}
                        style={blockIconStyle}
                    />
                }

                {title}

            </div>

            <div style={blockContentStyle}>
                {children}
            </div>

        </div>
    );
}


//--------------------------------------------------------
// Metric
//--------------------------------------------------------

function Metric({
    label,
    value
})
{
    return (
        <div style={metricStyle}>

            <div style={metricLabelStyle}>
                {label}
            </div>

            <div style={metricValueStyle}>
                {value}
            </div>

        </div>
    );
}


//--------------------------------------------------------
// Detail row
//--------------------------------------------------------

function DetailRow({
    icon,
    label,
    value
})
{
    return (
        <div style={detailRowStyle}>

            <div style={rowLabelStyle}>

                {
                    icon
                    &&
                    <FontAwesomeIcon
                        icon={icon}
                        style={rowIconStyle}
                    />
                }

                {label}

            </div>

            <div style={rowValueStyle}>
                {value}
            </div>

        </div>
    );
}


//--------------------------------------------------------
// Page styles
//--------------------------------------------------------

const pageStyle =
{
    position: "fixed",
    inset: 0,

    display: "flex",
    flexDirection: "column",

    paddingLeft: "60px",

    overflow: "hidden",

    background: "#ffffff"
};


const contentStyle =
{
    flex: 1,
    minHeight: 0,

    display: "flex",

    padding: 0,

    overflow: "hidden"
};


const detailPanelStyle =
{
    position: "relative",
    zIndex: 2,

    width: "400px",
    minWidth: "400px",
    height: "100%",

    display: "flex",
    flexDirection: "column",

    overflow: "hidden",

    background: "#ffffff",

    boxShadow:
        "16px 0 32px rgba(0, 0, 0, 0.22)"
};


const viewerFrameStyle =
{
    position: "relative",
    zIndex: 1,

    flex: 1,
    minWidth: 0,
    height: "100%",

    overflow: "hidden",

    background: "#171a1f"
};


const frameStyle =
{
    display: "block",

    width: "100%",
    height: "100%",

    border: "none"
};


//--------------------------------------------------------
// Detail header styles
//--------------------------------------------------------

const detailHeaderStyle =
{
    padding: "24px 24px 22px 24px",

    color: "#ffffff",

    background:
        "linear-gradient(145deg, #292e35 0%, #171a1f 55%, #101215 100%)",

    borderBottom:
        "1px solid rgba(255,255,255,0.08)",

    boxShadow:
        "0 10px 24px rgba(20, 26, 34, 0.16)"
};


const backButtonStyle =
{
    display: "flex",
    alignItems: "center",
    gap: "8px",

    margin: "0 0 23px 0",
    padding: 0,

    color: "#b4bfce",
    background: "transparent",
    border: "none",

    fontSize: "12px",
    fontWeight: "600",

    cursor: "pointer"
};


const eyebrowStyle =
{
    marginBottom: "8px",

    color: "#8fa0b8",

    fontSize: "10px",
    fontWeight: "800",
    letterSpacing: "1.7px"
};


const titleStyle =
{
    margin: "0 0 16px 0",

    color: "#ffffff",

    fontSize: "22px",
    lineHeight: "1.28",
    fontWeight: "750"
};



const badgeRowStyle =
{
    display: "flex",
    flexWrap: "wrap",
    gap: "7px"
};


const severityBadgeStyle =
{
    padding: "6px 10px",

    color: "#ffffff",

    borderRadius: "6px",

    fontSize: "10px",
    fontWeight: "800",
    letterSpacing: "0.7px"
};


const categoryBadgeStyle =
{
    padding: "6px 10px",

    color: "#d2dae5",

    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.13)",
    borderRadius: "6px",

    fontSize: "10px",
    fontWeight: "700",
    letterSpacing: "0.4px"
};


//--------------------------------------------------------
// Detail body styles
//--------------------------------------------------------

const detailBodyStyle =
{
    flex: 1,

    padding: "22px 24px 35px 24px",

    overflowY: "auto",

    background: "#ffffff"
};


const detailBlockStyle =
{
    marginBottom: "24px"
};


const blockHeadingStyle =
{
    display: "flex",
    alignItems: "center",
    gap: "8px",

    marginBottom: "10px",

    color: "#292f38",

    fontSize: "12px",
    fontWeight: "750",
    letterSpacing: "0.2px"
};


const blockIconStyle =
{
    width: "14px",

    color: "#477df5"
};


const blockContentStyle =
{
    color: "#606b7a",

    fontSize: "12.5px",
    lineHeight: "1.65"
};


//--------------------------------------------------------
// Metric styles
//--------------------------------------------------------

const metricGridStyle =
{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "9px",

    marginBottom: "25px"
};


const metricStyle =
{
    minWidth: 0,

    padding: "13px",

    background:
        "linear-gradient(145deg, #f7f8fa 0%, #f0f2f5 100%)",

    border: "1px solid #e0e4e9",
    borderRadius: "6px"
};


const metricLabelStyle =
{
    marginBottom: "6px",

    overflow: "hidden",

    color: "#8490a0",

    fontSize: "9px",
    fontWeight: "800",
    letterSpacing: "0.8px",
    textOverflow: "ellipsis",
    textTransform: "uppercase",
    whiteSpace: "nowrap"
};


const metricValueStyle =
{
    overflow: "hidden",

    color: "#272d36",

    fontSize: "14px",
    fontWeight: "750",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};


//--------------------------------------------------------
// Row styles
//--------------------------------------------------------

const detailRowStyle =
{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    gap: "12px",

    padding: "10px 0",

    borderBottom: "1px solid #e8ebef"
};


const rowLabelStyle =
{
    display: "flex",
    alignItems: "center",
    gap: "8px",

    color: "#737f8f",

    fontSize: "11.5px"
};


const rowIconStyle =
{
    width: "12px",

    color: "#8a98aa"
};


const rowValueStyle =
{
    color: "#29303a",

    fontSize: "11.5px",
    fontWeight: "700",
    textAlign: "right"
};


//--------------------------------------------------------
// Loading and empty styles
//--------------------------------------------------------

const messageStyle =
{
    flex: 1,

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",

    padding: "30px",

    textAlign: "center"
};


const messageIconStyle =
{
    marginBottom: "17px",

    color: "#477df5",

    fontSize: "30px"
};


const messageTitleStyle =
{
    marginBottom: "7px",

    color: "#282e37",

    fontSize: "16px",
    fontWeight: "750"
};


const messageTextStyle =
{
    color: "#8490a0",

    fontSize: "12px",
    lineHeight: "1.5"
};


const spinnerStyle =
{
    width: "30px",
    height: "30px",

    marginBottom: "17px",

    border: "3px solid #e2e6eb",
    borderTopColor: "#477df5",
    borderRadius: "50%",

    animation: "spin 0.8s linear infinite"
};


const actionBarStyle =
{
    position: "relative",
    zIndex: 3,

    display: "grid",
    gridTemplateColumns: "1fr 1fr auto",
    gap: "8px",

    padding: "14px 16px",

    background:
        "linear-gradient(180deg, #ffffff 0%, #f7f8fa 100%)",

    borderTop: "1px solid #dfe4ea",

    boxShadow:
        "0 -10px 24px rgba(28, 38, 52, 0.08)"
};


const primaryActionStyle =
{
    minHeight: "38px",
    padding: "8px 12px",

    color: "#ffffff",

    background:
        "linear-gradient(135deg, #4d87ff 0%, #2563eb 100%)",

    border: "1px solid #2864e5",
    borderRadius: "7px",

    boxShadow:
        "0 5px 12px rgba(37, 99, 235, 0.22)",

    fontSize: "11px",
    fontWeight: "750",

    cursor: "pointer"
};


const secondaryActionStyle =
{
    minHeight: "38px",
    padding: "8px 10px",

    color: "#39475a",

    background:
        "linear-gradient(180deg, #ffffff 0%, #edf1f5 100%)",

    border: "1px solid #d5dce5",
    borderRadius: "7px",

    fontSize: "11px",
    fontWeight: "750",

    cursor: "pointer"
};


const mergeActionStyle =
{
    minHeight: "38px",
    padding: "8px 13px",

    color: "#687588",

    background: "#ffffff",

    border: "1px solid #d5dce5",
    borderRadius: "7px",

    fontSize: "11px",
    fontWeight: "750",

    cursor: "pointer"
};


const otherInsightsButtonStyle =
{
    position: "absolute",
    zIndex: 4,

    top: "22px",
    right: "22px",

    display: "flex",
    alignItems: "center",
    gap: "11px",

    minWidth: "215px",

    padding: "9px 11px",

    color: "#ffffff",

    background:
        "linear-gradient(145deg, rgba(42,47,55,0.96) 0%, rgba(18,21,25,0.96) 100%)",

    border:
        "1px solid rgba(255,255,255,0.18)",

    borderRadius: "11px",

    boxShadow:
        "0 10px 28px rgba(0,0,0,0.30)",

    backdropFilter: "blur(14px)",

    cursor: "pointer"
};


const otherInsightsIconStyle =
{
    width: "34px",
    height: "34px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    flexShrink: 0,

    color: "#ffffff",

    background:
        "linear-gradient(135deg, #4d87ff 0%, #2563eb 100%)",

    borderRadius: "8px",

    boxShadow:
        "0 5px 12px rgba(37,99,235,0.30)",

    fontSize: "14px"
};


const otherInsightsTextStyle =
{
    flex: 1,

    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",

    minWidth: 0
};


const otherInsightsLabelStyle =
{
    color: "#ffffff",

    fontSize: "11px",
    fontWeight: "750",
    whiteSpace: "nowrap"
};


const otherInsightsCountTextStyle =
{
    marginTop: "2px",

    color: "#9da9ba",

    fontSize: "9px",
    fontWeight: "600"
};


const otherInsightsCountStyle =
{
    minWidth: "27px",
    height: "27px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    color: "#dfe7f3",

    background: "rgba(255,255,255,0.09)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "7px",

    fontSize: "11px",
    fontWeight: "800"
};


//--------------------------------------------------------
// Detail navigation
//--------------------------------------------------------

const detailNavigationStyle =
{
    flexShrink: 0,

    padding: "14px 24px",

    background:
        "linear-gradient(145deg, #292e35 0%, #171a1f 100%)",

    borderBottom:
        "1px solid rgba(255,255,255,0.08)"
};